<p-confirmDialog />

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCount }}</span>
          <span class="stats-card-label">Notifications</span>
          <span class="stats-card-sublabel">All system emails</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-envelope"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ enabledCount }}</span>
          <span class="stats-card-label">Enabled</span>
          <span class="stats-card-sublabel">Currently sending</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ disabledCount }}</span>
          <span class="stats-card-label">Disabled</span>
          <span class="stats-card-sublabel">Not sending</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-ban"></i></div>
      </div>
      <div class="stats-card" [class.stats-card--warning]="willNotSendCount > 0"
           [class.stats-card--total]="willNotSendCount === 0"
           [class.stats-card-clickable]="willNotSendCount > 0"
           (click)="willNotSendCount > 0 && showOnlyWillNotSend()">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ willNotSendCount }}</span>
          <span class="stats-card-label">Need recipients</span>
          <span class="stats-card-sublabel">
            {{ willNotSendCount > 0 ? 'On, but nobody to send to' : 'All set up' }}
          </span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-exclamation-triangle"></i></div>
      </div>
    </div>

    <!-- Master switch, deliberately separated from the per-notification rows -->
    <div class="master-switch" [class.master-switch--off]="!isMasterEnabled" *ngIf="masterSwitch">
      <div class="master-switch-icon">
        <i class="pi" [ngClass]="isMasterEnabled ? 'pi-send' : 'pi-exclamation-triangle'"></i>
      </div>
      <div class="master-switch-body">
        <div class="master-switch-title">
          {{ masterSwitch.displayName }}
          <p-tag *ngIf="!isMasterEnabled" severity="danger" value="ALL EMAIL OFF" />
        </div>
        <div class="master-switch-desc">{{ masterSwitch.autoRecipientDescription }}</div>
      </div>
      <div class="master-switch-control">
        <p-toggleSwitch [(ngModel)]="masterSwitch.isEnabled" (onChange)="toggleMaster()" />
      </div>
    </div>

    <div class="config-note config-note--warning" *ngIf="willNotSendCount > 0">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        <strong>{{ willNotSendCount }}</strong>
        {{ willNotSendCount === 1 ? 'notification is' : 'notifications are' }}
        switched on but {{ willNotSendCount === 1 ? 'has' : 'have' }} no recipients, so
        {{ willNotSendCount === 1 ? 'it' : 'they' }} will not send to anyone.
        <a class="config-note-link" (click)="showOnlyWillNotSend()">Show {{ willNotSendCount === 1 ? 'it' : 'them' }}</a>
      </span>
    </div>

    <div class="config-note" *ngIf="willNotSendCount === 0">
      <i class="pi pi-info-circle"></i>
      <span>
        Recipients are managed here. Pick people from the list or type any other address, such as a
        shared mailbox. A notification with no recipients does not send.
      </span>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="categoryFilter" class="filter-label">Category</label>
          <p-select id="categoryFilter" [(ngModel)]="selectedCategoryFilter" (ngModelChange)="onFilterChange()"
            [options]="categoryFilterOptions" optionLabel="label" optionValue="value" placeholder="All categories"
            [showClear]="true" [filter]="true" filterPlaceholder="Search category..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="typeFilter" class="filter-label">Recipients</label>
          <p-select id="typeFilter" [(ngModel)]="selectedRecipientTypeFilter" (ngModelChange)="onFilterChange()"
            [options]="recipientTypeFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions">
        <p-button [label]="allCollapsed ? 'Expand all' : 'Collapse all'"
          [icon]="allCollapsed ? 'pi pi-angle-double-down' : 'pi pi-angle-double-up'"
          (onClick)="allCollapsed ? expandAll() : collapseAll()"
          severity="secondary" [text]="true" size="small" />
        <button type="button" class="btn-clear-filters" *ngIf="hasActiveFilters()"
          (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <div class="loading-state" *ngIf="loading">
      <i class="pi pi-spin pi-spinner"></i> Loading notification settings...
    </div>

    <div class="empty-state" *ngIf="!loading && filteredSettings.length === 0">
      <div class="empty-icon"><i class="pi pi-inbox"></i></div>
      <p class="empty-message">No notifications found</p>
      <p class="empty-description">Try a different search term</p>
    </div>

    <!-- Own scroll region, mirroring how every table page works: a p-table with scrollHeight="flex"
         scrolls internally, so the sticky filter bar above it never has content passing underneath.
         Without this the whole page scrolls and rows slide behind the bar. -->
    <div class="notif-list">

    <!-- One section per category -->
    <div class="notif-group" *ngFor="let category of categories">
      <div class="notif-group-header" (click)="toggleCategory(category)">
        <span class="notif-group-title">
          <i class="pi" [ngClass]="isCollapsed(category) ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
          {{ category }}
        </span>
        <span class="notif-group-count">{{ enabledIn(category) }} of {{ settingsIn(category).length }} enabled</span>
      </div>

      <!-- *ngIf, not [hidden]: .notif-row sets `display: flex`, which overrides the hidden
           attribute's `display: none`, so collapsing left every row on screen. -->
      <div class="notif-row" *ngFor="let row of (isCollapsed(category) ? [] : settingsIn(category))"
           [class.notif-row--disabled]="!row.isEnabled || !isMasterEnabled"
           [class.notif-row--warning]="willNotSend(row)">

        <div class="notif-row-toggle">
          <p-toggleSwitch [(ngModel)]="row.isEnabled" (onChange)="onToggle(row)"
            [disabled]="isSaving(row)" />
        </div>

        <div class="notif-row-main">
          <div class="notif-row-name">
            {{ row.displayName }}
            <i class="pi pi-question-circle notif-help" *ngIf="row.description"
               [pTooltip]="row.description" tooltipPosition="top"></i>
            <i class="pi pi-spin pi-spinner notif-saving" *ngIf="isSaving(row)"></i>
          </div>

          <!-- Editable recipients: summary plus an Edit button opening the three-source dialog -->
          <div class="notif-row-recipients" *ngIf="row.areRecipientsEditable">
            <div class="notif-row-summary">
              <span class="notif-sends-to">Sends to</span>

              <span class="notif-chip-note notif-chip-note--group" *ngIf="groupNameFor(row)">
                <i class="pi pi-users"></i> {{ groupNameFor(row) }}
              </span>

              <span *ngFor="let email of allRecipients(row)" class="notif-chip-note"
                    [class.notif-chip-note--external]="!isKnownEmployee(email)"
                    [pTooltip]="email" tooltipPosition="top">
                {{ isKnownEmployee(email) ? recipientLabel(email) : email }}
                <span class="notif-chip-tag" *ngIf="!isKnownEmployee(email)">external</span>
              </span>

              <span class="notif-chip-empty" *ngIf="willNotSend(row)">nobody</span>

              <p-button label="Edit" icon="pi pi-pencil" (onClick)="openEdit(row)"
                severity="secondary" [text]="true" size="small" [disabled]="isSaving(row)" />
            </div>

            <div class="notif-row-error" *ngIf="willNotSend(row)">
              <i class="pi pi-exclamation-triangle"></i>
              Nobody will receive this &mdash; click Edit to add recipients.
            </div>
            <div class="notif-row-auto" *ngIf="row.autoRecipientDescription && !willNotSend(row)">
              <i class="pi pi-plus-circle"></i> {{ row.autoRecipientDescription }}
            </div>
          </div>

          <!-- Auto-derived recipients: read-only explanation -->
          <div class="notif-row-recipients" *ngIf="!row.areRecipientsEditable">
            <div class="notif-row-auto notif-row-auto--only">
              <i class="pi pi-lock"></i>
              {{ row.autoRecipientDescription || 'Recipients are determined automatically.' }}
            </div>
            <div class="notif-row-adgroup" *ngIf="row.adGroupConfigKey">
              <i class="pi pi-sitemap"></i> Entra ID group: <code>{{ row.adGroupConfigKey }}</code>
            </div>
          </div>
        </div>

        <div class="notif-row-status">
          <p-tag [severity]="row.isEnabled ? 'success' : 'danger'"
            [value]="row.isEnabled ? 'On' : 'Off'" />
        </div>
      </div>

      <!-- Per-service-group contract recipients, shown once beneath the contract notifications.
           These are additive: each contract also reaches the heads of its own service group. -->
      <div class="notif-sg-panel" *ngIf="!isCollapsed(category) && serviceGroups.length > 0
             && settingsIn(category).length > 0 && isContractNotification(settingsIn(category)[0])">
        <div class="notif-sg-header" (click)="toggleServiceGroups()">
          <span class="notif-sg-title">
            <i class="pi" [ngClass]="serviceGroupsExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            Per service group
          </span>
          <span class="notif-sg-count">
            {{ serviceGroupsWithRecipients }} of {{ serviceGroups.length }} have recipients
          </span>
        </div>

        <div class="notif-sg-body" *ngIf="serviceGroupsExpanded">
          <p class="notif-sg-intro">
            Contract emails above also go to the heads of that contract's service group, so a
            Software contract reaches the Software heads and an IT contract reaches the IT heads.
          </p>

          <div class="notif-sg-row" *ngFor="let sg of serviceGroups">
            <span class="notif-sg-name">{{ sg.name }}</span>
            <p-multiSelect [(ngModel)]="serviceGroupSelections[sg.id]" [options]="employeeOptions"
              optionLabel="label" optionValue="value" placeholder="No recipients"
              [filter]="true" filterPlaceholder="Search by name or email..."
              display="chip" [showToggleAll]="true" [showClear]="true" [maxSelectedLabels]="3"
              selectedItemsLabel="{0} people"
              [disabled]="isSavingServiceGroup(sg)"
              appendTo="body" panelStyleClass="filter-dropdown-panel"
              (onPanelHide)="saveServiceGroup(sg)" (onClear)="saveServiceGroup(sg)" />
            <i class="pi pi-spin pi-spinner notif-saving" *ngIf="isSavingServiceGroup(sg)"></i>
          </div>
        </div>
      </div>
    </div>

    </div><!-- /.notif-list -->

  </div>
</div>

<p-dialog [visible]="editDialogVisible" (visibleChange)="editDialogVisible = $event"
  [header]="editingRow ? 'Recipients — ' + editingRow.displayName : 'Recipients'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true"
  (onHide)="closeEdit()">

  <div class="form-dialog-form form-dialog-compact" *ngIf="editingRow">
    <div class="form-dialog-container">

      <div class="form-row">
        <div class="field">
          <label for="editGroup">A team</label>
          <p-select id="editGroup" [(ngModel)]="editGroupKey" [options]="groupSelectOptions"
            optionLabel="label" optionValue="value" optionDisabled="disabled"
            placeholder="No team" appendTo="body" panelStyleClass="filter-dropdown-panel" />
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="editEmployees">People</label>
          <p-multiSelect id="editEmployees" [(ngModel)]="editEmployees" [options]="employeeOptions"
            optionLabel="label" optionValue="value" placeholder="Search and select people"
            [filter]="true" filterPlaceholder="Search by name or email..."
            display="chip" [showToggleAll]="true" [showClear]="true" [maxSelectedLabels]="5"
            selectedItemsLabel="{0} people selected"
            appendTo="body" panelStyleClass="filter-dropdown-panel" />
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="editOther">Any other email address</label>
          <div class="notif-other-input">
            <input pInputText id="editOther" [(ngModel)]="editOtherInput"
              placeholder="e.g. accounts@bistecglobal.com — then press Enter"
              (keydown.enter)="$event.preventDefault(); addOtherEmail()" />
            <p-button icon="pi pi-plus" label="Add" (onClick)="addOtherEmail()"
              severity="secondary" [outlined]="true" size="small" />
          </div>
          <div class="notif-row-chips" *ngIf="editOther.length > 0">
            <span *ngFor="let email of editOther" class="notif-chip-note notif-chip-note--external">
              {{ email }}
              <i class="pi pi-times notif-chip-remove" (click)="removeOtherEmail(email)"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- Shows the outcome of the three fields above, so it reads as one answer -->
      <div class="notif-dialog-summary" [class.notif-dialog-summary--empty]="editHasNoRecipients">
        <i class="pi" [ngClass]="editHasNoRecipients ? 'pi-exclamation-triangle' : 'pi-send'"></i>
        <span *ngIf="!editHasNoRecipients">
          This email goes to <strong>{{ editSummary }}</strong>
        </span>
        <span *ngIf="editHasNoRecipients">
          Nobody selected &mdash; this email will not be sent
        </span>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="closeEdit()"
        severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveEdit()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
